import React from 'react'
import PropTypes from 'prop-types'
import Subheader from 'material-ui/Subheader'
import FormInput from './bases/FormInput'
import FormLabel from '../labels/FormLabel'
import { returnNumber } from 'helpers/numberHelpers'

const borderStyle = {
  border: '1px solid #e8e8e8',
  borderRadius: 5,
  marginBottom: 10,
  padding: 15,
  marginTop: 10,
}
const wrapperStyle = {
  position: 'relative',
  width: '100%',
  height: 200,
  paddingBottom: 40,
}

const fieldStyles = {
  base: { position: 'absolute' },
  top: { top: 0, left: '35%' },
  left: { left: 0, top: '25%' },
  right: { right: 0, top: '25%'},
  bottom: { bottom: '10%', left: '35%' },
}

const inputStyles = {
  base: { width: 100, },
  left: { marginLeft: 45 },
  right: { marginRight: 45 },
}

const SpacingPicker = ({
  label,
  top,
  bottom,
  left,
  right,
  onChange,
  hasBorder,
}) => {
  const handleChange = (val, key) => {
    return returnNumber(val, (number) => onChange(number, key))
  }
  return (
    <div style={{ ...wrapperStyle, ...hasBorder && borderStyle }}>
      <FormLabel dark>{label}</FormLabel>
      <div style={{ ...fieldStyles.base, ...fieldStyles.top }}>
        <FormInput
          style={inputStyles.base}
          label="Top"
          value={top}
          onChange={(val) => handleChange(val, 'Top')}
        />
      </div>
      <div style={{ ...fieldStyles.base, ...fieldStyles.left }}>
        <FormInput
          style={{ ...inputStyles.base, ...inputStyles.left }}
          label="Left"
          value={left}
          onChange={(val) => handleChange(val, 'Left')}
        />
      </div>
      <div style={{ ...fieldStyles.base, ...fieldStyles.right }}>
        <FormInput
          style={{ ...inputStyles.base, ...inputStyles.right }}
          label="Right"
          value={right}
          onChange={(val) => handleChange(val, 'Right')}
        />
      </div>
      <div style={{ ...fieldStyles.base, ...fieldStyles.bottom }}>
        <FormInput
          style={inputStyles.base}
          label="Bottom"
          value={bottom}
          onChange={(val) => handleChange(val, 'Bottom')}
        />
      </div>
    </div>
  )
}

SpacingPicker.propTypes = {}
SpacingPicker.defaultProps = {}

export default SpacingPicker



// WEBPACK FOOTER //
// ./src/components/forms/SpacingPicker.js